var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { CONFIG } from "@rentiohq/shared-frontend/dist/config/app.config";
import { filterFilesMatchingContent } from "@rentiohq/shared-frontend/dist/reduxV2/documents/document.utils";
import { getLocalizedText } from "@rentiohq/shared-frontend/dist/utils/i18n/i18n.utils";
import { formatBytes } from "@rentiohq/shared-frontend/dist/utils/number.utils";
import { uniqBy } from "lodash";
import { useDropzone } from "react-dropzone";
import { ASSETS } from "../../assets";
import { enqueueSnackbar } from "../../utils/snackbar";
import { Menu } from "../Menu";
import { UploadFieldStyles } from "./UploadField.styles";
export var showDropErrors = function (params) {
    var fileRejections = params.fileRejections, _a = params.maxFileSize, maxFileSize = _a === void 0 ? CONFIG.UPLOAD_MAX_FILE_SIZE : _a, _b = params.minFileSize, minFileSize = _b === void 0 ? CONFIG.UPLOAD_MIN_FILE_SIZE : _b;
    fileRejections.forEach(function (_a) {
        var errors = _a.errors, file = _a.file;
        errors.forEach(function (error) {
            switch (error.code) {
                case "file-too-large":
                    enqueueSnackbar("".concat(file.name, ": ").concat(getLocalizedText("files.error.size_limit_exceeded", {
                        size: formatBytes(maxFileSize),
                    })), { variant: "error" });
                    break;
                case "file-too-small":
                    enqueueSnackbar("".concat(file.name, ": ").concat(getLocalizedText("files.error.size_too_small", {
                        size: formatBytes(minFileSize),
                    })), { variant: "error" });
                default:
                    break;
            }
        });
    });
};
export var UploadField = function (props) {
    var id = props.id, name = props.name, onChange = props.onChange, _a = props.asDropzone, asDropzone = _a === void 0 ? true : _a, _b = props.multiple, multiple = _b === void 0 ? false : _b, _c = props.disabled, disabled = _c === void 0 ? false : _c, _d = props.maxFileSize, maxFileSize = _d === void 0 ? CONFIG.UPLOAD_MAX_FILE_SIZE : _d, _e = props.minFileSize, minFileSize = _e === void 0 ? CONFIG.UPLOAD_MIN_FILE_SIZE : _e, accept = props.accept, required = props.required, error = props.error, formikProps = props.formikProps;
    var dropzoneProps = {
        onDrop: handleDrop,
        multiple: multiple,
        maxSize: maxFileSize,
        minSize: minFileSize,
        disabled: disabled,
        accept: accept,
    };
    var _f = useDropzone(dropzoneProps), getRootProps = _f.getRootProps, getInputProps = _f.getInputProps, isDragActive = _f.isDragActive;
    var sx = UploadFieldStyles({
        hasError: Boolean(error),
        isDraggingOver: isDragActive,
    });
    var selectedFiles = (formikProps === null || formikProps === void 0 ? void 0 : formikProps.values[id]) || [];
    function handleDrop(acceptedFiles, fileRejections, event) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, valid, invalid, newFilesSet;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        showDropErrors({
                            acceptedFiles: acceptedFiles,
                            fileRejections: fileRejections,
                            event: event,
                            maxFileSize: maxFileSize,
                            minFileSize: minFileSize,
                        });
                        if (acceptedFiles.length === 0) {
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, filterFilesMatchingContent(acceptedFiles)];
                    case 1:
                        _a = _b.sent(), valid = _a.valid, invalid = _a.invalid;
                        invalid.forEach(function (_a) {
                            var file = _a.file, message = _a.message;
                            enqueueSnackbar("".concat(file.name, ": ").concat(message), { variant: "error" });
                        });
                        if (valid.length === 0) {
                            return [2 /*return*/];
                        }
                        if (multiple) {
                            newFilesSet = uniqBy(__spreadArray(__spreadArray([], selectedFiles, true), valid, true), "name");
                            onChange(newFilesSet);
                            return [2 /*return*/];
                        }
                        onChange(valid);
                        return [2 /*return*/];
                }
            });
        });
    }
    function handleChange(_a) {
        var acceptedFiles = _a.target.files;
        if (multiple) {
            var newFilesSet = uniqBy(__spreadArray(__spreadArray([], selectedFiles, true), acceptedFiles, true), "name");
            onChange(newFilesSet);
            return;
        }
        onChange(acceptedFiles);
    }
    function handleRemoveFile(file) {
        onChange(selectedFiles.filter(function (selectedFile) { return selectedFile.name !== file.name; }));
    }
    // To accept all, just leave the 'accept' prop out.
    // if (accept && accept !== "*") dropzoneProps.accept = accept;
    if (asDropzone)
        return (_jsxs(_Fragment, { children: [selectedFiles
                    ? selectedFiles.map(function (file) { return (_jsxs(Stack, { justifyContent: "space-between", flexDirection: "row", alignItems: "center", mb: 2, children: [_jsxs(Stack, { children: [_jsx(Typography, { variant: "caption", sx: sx.content.fileName, children: file.name }), _jsx(Typography, { variant: "caption", sx: sx.content.fileSize, children: formatBytes(file.size) })] }), _jsx(Box, { children: _jsx(Menu, { actions: [
                                        {
                                            label: "system.remove",
                                            onClick: function () { return handleRemoveFile(file); },
                                        },
                                    ] }) })] }, file.name)); })
                    : null, _jsxs(Box, __assign({}, getRootProps(), { sx: sx.wrapper, children: [_jsx("input", __assign({ id: id, name: typeof name === "string" ? name : undefined, multiple: multiple }, getInputProps())), _jsxs(Stack, { direction: "row", gap: 2, alignItems: "center", children: [_jsx("img", { src: ASSETS.uploadFile, alt: "uploadFile" }), _jsxs(Stack, { direction: "column", gap: 1, children: [_jsx(Typography, { variant: "h5", sx: sx.content.placeHolderTitle, children: getLocalizedText("system.upload.label") }), _jsx(Typography, { variant: "subtitle2", children: isDragActive
                                                ? getLocalizedText("system.upload.drag_placeholder")
                                                : getLocalizedText("system.upload.select_placeholder") })] })] })] }))] }));
    return (_jsx("input", { id: id, name: typeof name === "string" ? name : undefined, required: required, type: "file", onChange: handleChange, defaultValue: "", multiple: multiple, accept: accept, disabled: disabled }));
};
